import React from "react";
import "./PricingPlans.css";

const PLAN_LIMITS = {
  free: 2,
  pro: 10,
  elite: 25,
  luxe: 100,
};
const PricingPlans = () => {
  return (
    <div className="pricing-section">
      <div className="notice-bar">
        <p>
          You get <strong>2 Free Itineraries</strong> to try TravXplo's planner!
        </p>
        <button
          className="btn-notice"
          onClick={() => (window.location.href = "/AIItinerary")}
        >
          Try Itinerary Planner
        </button>
      </div>

      <h1 className="pricing-title">Choose Your Travel Plan</h1>
      <div className="plans-container">
        {/* Pro Traveler */}
        <div className="plan-card">
          <h2 className="plan-name">Pro Traveler</h2>
          <p className="plan-price">₹249</p>
          <ul className="plan-features">
            <li>✔ 5 itineraries (valid 30 days)</li>
            <li>✔ Save up to 10 trips</li>
            <li>✔ 1 hotel suggestion per city</li>
            <li>✔ Flights: basic text only</li>
            <li>✔ Email support (within 12 hrs)</li>
          </ul>
          <a
            href="/PaymentPage" // <-- Instamojo link for Pro
            target="_blank"
            rel="noopener noreferrer"
          >
            <button className="select-btn">Select Plan</button>
          </a>
        </div>

        {/* Elite Traveler */}
        <div className="plan-card best-value">
          <div className="badge">Best Value</div>
          <h2 className="plan-name">Elite Traveler</h2>
          <p className="plan-price">₹599</p>
          <ul className="plan-features">
            <li>✔ 15 itineraries (valid 90 days)</li>
            <li>✔ Save up to 30 trips</li>
            <li>✔ 2 hotel suggestions per city</li>
            <li>✔ Flights: full details with links</li>
            <li>✔ Priority email (within 5 hrs)</li>
            <li>✔ 1 call with Travel Expert</li>
          </ul>

          <a
            href="/PaymentPage" // <-- Instamojo link for Pro
            target="_blank"
            rel="noopener noreferrer"
          >
            <button className="select-btn">Select Plan</button>
          </a>
        </div>

        {/* Luxe Traveler */}
        <div className="plan-card">
          <h2 className="plan-name">Luxe Traveler</h2>
          <p className="plan-price">₹1199</p>
          <ul className="plan-features">
            <li>✔ 40 itineraries (valid 120 days)</li>
            <li>✔ Save up to 80 trips</li>
            <li>✔ 4 hotel suggestions per city</li>
            <li>✔ Flights: full details with links</li>
            <li>✔ Priority email (within 2 hrs)</li>
            <li>✔ Dedicated Travel Expert (constant support)</li>
            <li>✔ Early access to new AI tools & features</li>
          </ul>
          <a
            href="/PaymentPage"
            // href="https://imjo.in/xuX8bP" // <-- Instamojo link for Pro
            // target="_blank"
            // rel="noopener noreferrer"
          >
            <button className="select-btn">Select Plan</button>
          </a>
        </div>
      </div>
    </div>
  );
};

export default PricingPlans;
